import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaHeart } from 'react-icons/fa';

function PostCard({ post, onFavorite, onShare }) {
  return (
    <div className="post-card">
      <img src={post.image} alt={post.title} />
      <div className="post-card-content">
        <h3>{post.title}</h3>
        <div className="post-card-meta">
          <span>{post.date}</span>
          <span>{post.author}</span>
        </div>
        <p>{post.excerpt}</p>
        <div className="post-card-actions">
          <Link to={`/post/${post.id}`} className="btn btn-primary">
            <FaShoppingCart />
            Διαβάστε Περισσότερα
          </Link>
          <button onClick={() => onShare(post.id)} className="btn btn-secondary">
            Κοινοποίηση
          </button>
          <button onClick={() => onFavorite(post.id)} className="btn btn-outline">
            <FaHeart />
            Αγαπημένα
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostCard;